import * as request from "@/utils/request";
import { DefaultConfigs, isOnline, isPre } from "@/common/js/constant";
import { BannerList, DetailResponse, ReportTriggerEventParams } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;
const payinBaseUrl = isOnline
  ? "https://m.didipay.com"
  : isPre
    ? "https://m.intra.didipay.com"
    : baseUrl;
const payinApiPrefix = isOnline || isPre ? "sofipo-api" : "sofipo";

const getOs = (): "iOS" | "Android" => {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase() : "";
  if (/iphone|ipad|ipod|ios|macintosh/.test(ua)) {
    return "iOS";
  }
  return "Android";
};

type RawResponse<T> = {
  errno: number;
  errNo?: number;
  errmsg?: string;
  errMsg?: string;
  data: T;
};

// 获取充值页资源位列表
export function getBannerList() {
  return request.get<BannerList>(`${baseUrl}/sofipo/v0/trade/payin/getBanner`, {});
}

// 获取充值页详情
export function getDetail() {
  return request.post<DetailResponse>(`${baseUrl}/sofipo/v0/trade/payin/getCreateUrl`, {
    platform: getOs(),
  });
}

export function getDetailRaw() {
  return request.post<RawResponse<DetailResponse>>(
    `${baseUrl}/sofipo/v0/trade/payin/getCreateUrl`,
    { platform: getOs() },
    { raw: true },
  );
}

// 获取SPEI充值页详情
export function getSPEIDetail(type: string) {
  return request.post<DetailResponse>(`${baseUrl}/sofipo/v0/trade/payin/fusion`, { type });
}

// 获取AB实验入金页详情
export function getSPEIAbTestDetail(type: string) {
  return request.post<import("./types").AbTestDetailResponse>(
    `${payinBaseUrl}/${payinApiPrefix}/v0/trade/payin/benefit`,
    { type, platform: getOs() },
  );
}

export function getSPEIAbTestDetailRaw(type: string) {
  return request.post<RawResponse<import("./types").AbTestDetailResponse>>(
    `${payinBaseUrl}/${payinApiPrefix}/v0/trade/payin/benefit`,
    { type, platform: getOs() },
    { raw: true },
  );
}

export function reportTriggerEvent(params: ReportTriggerEventParams) {
  return request.post(`${baseUrl}/sofipo/v0/trigger/reportEvent`, params);
}
